export function OlapReport(data) {
    const {
        id,
        name,
        category_id: category,
        responsible,
        has_chat: chat,
        description,
        reportFiles: files,
        sort,
    } = data;

    return {
        id,
        name,
        category,
        responsible: responsible && responsible.id ? responsible : null,
        chat: !!Number(chat),
        description,
        files: (files || []).map((file) => {
            const { id, name } = file;

            return {
                id,
                url: name,
                name: name.split("/").pop(),
            };
        }),
        hasDescription: description || files.length,
        sort,
    };
}

export function formatOlapReport(data) {
    const { id, name, category, responsible, chat, files, oldFiles, description } = data;

    return {
        id,
        name,
        category_id: category,
        responsible_id: responsible,
        has_chat: chat ? 1 : 0,
        files,
        oldFiles,
        description,
    };
}
